export default __webpack_public_path__ + "static/media/careadmin_girl.c6730dab.svg";